// import React, { useState } from "react";
// import { Nav } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import Logo from "../../assets/img/j.png";
// import {
//   AiOutlineSearch,
//   AiOutlineShoppingCart,
//   AiOutlineUser,
// } from "react-icons/ai";

// export default function Mobile() {
//   let [menuBar, setMenuBar] = useState("collapse");
//   const toggleMenu = () => {
//     setMenuBar(menuBar === "collapse show" ? "collapse" : menuBar);
//   };
//   return (
//     <>
//       <Nav
//         className="bar-expand-lg navbar-light shadow d-lg-none"
//         style={{
//           backgroundColor: "rgb(245, 212, 78)",
//           position: "sticky",
//           top: 0,
//           zIndex: 3,
//         }}
//       >
//         <div className="container d-flex justify-content-between align-items-center">
//           <Link
//             className="logo align-self-center"
//             to="/"
//             style={{ width: "25%", textDecoration: "none", color: "black" }}
//           >
//             {/* <img src={Logo} alt="sivam farms logo" height="auto" width="50%" /> */}
//             chakara art and craft
//           </Link>

//           <button
//             className="navbar-toggler border-0"
//             type="button"
//             onClick={() => {
//               toggleMenu();
//             }}
//             data-bs-toggle={menuBar}
//             data-bs-target="#templatemo_main_nav"
//             aria-controls="navbarSupportedContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           <div
//             className="align-self-center collapse navbar-collapse flex-fill  d-lg-flex justify-content-lg-between"
//             id="templatemo_main_nav"
//           >
//             <div className="flex-fill">
//               <ul className="nav navbar-nav d-flex justify-content-between mx-lg-auto">
//                 <li className="nav-item">
//                   <Link
//                     className="nav-link"
//                     to="/"
//                     onClick={() => toggleMenu()}
//                   >
//                     Home
//                   </Link>
//                 </li>

//                 <li className="nav-item">
//                   <Link className="nav-link" to="/herbalProduct">
//                     sthachu
//                   </Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link className="nav-link" to="/gardenProduct">
//                     Garden Products
//                   </Link>
//                 </li>
//                 {/* <li className="nav-item">
//                   <Link className="nav-link" to="/yogaProduct">
//                     Yoga Products
//                   </Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link className="nav-link" to="/spices">
//                     Spices
//                   </Link>
//                 </li> */}
//                 <li className="nav-item">
//                   <Link className="nav-link" to="/foodProduct">
//                     Food Products
//                   </Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link className="nav-link" to="/about">
//                     About
//                   </Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link
//                     to="/cart/:productId"
//                     className="nav-icon position-relative text-decoration-none"
//                   >
//                     <AiOutlineShoppingCart style={{ fontSize: "1.7em" }} />
//                     {/* <label className="position-absolute top-0 left-100 translate-middle badge rounded-pill bg-danger text-light">
//                       4
//                     </label> */}
//                   </Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link
//                     to="/profile/:productId"
//                     className="nav-icon position-relative text-decoration-none"
//                   >
//                     <AiOutlineUser style={{ fontSize: "1.7em" }} />
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </Nav>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { Nav } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import { AiOutlineShoppingCart, AiOutlineUser } from "react-icons/ai";

// export default function Mobile() {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const toggleMenu = () => {
//     setMenuOpen(!menuOpen);
//   };

//   useEffect(() => {
//     if (menuOpen) {
//       document.body.style.overflow = "hidden"; // Prevent scrolling
//     } else {
//       document.body.style.overflow = "auto"; // Restore scrolling
//     }

//     return () => {
//       document.body.style.overflow = "auto"; // Cleanup when component unmounts
//     };
//   }, [menuOpen]);

//   return (
//     <>
//       {/* Fixed Navbar */}
//       <Nav
//         className="navbar navbar-light shadow d-lg-none fixed-top"
//         style={{
//           backgroundColor: "rgb(245, 212, 78)",
//           zIndex: 1050, // Ensures navbar is on top
//         }}
//       >
//         <div className="container d-flex justify-content-between align-items-center">
//           <Link
//             className="logo align-self-center"
//             to="/"
//             style={{ width: "25%", textDecoration: "none", color: "black" }}
//           >
//             chakara art and craft
//           </Link>

//           <button
//             className="navbar-toggler border-0"
//             type="button"
//             onClick={toggleMenu}
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>
//         </div>
//       </Nav>

//       {/* Mobile Menu */}
//       <div
//         className={`collapse ${menuOpen ? "show" : ""}`}
//         id="mobile_menu"
//         style={{
//           position: "fixed",
//           top: "56px", // Adjust this value based on navbar height
//           left: 0,
//           width: "100%",
//           height: "100vh",
//           backgroundColor: "white",
//           overflowY: "auto",
//           zIndex: 1049,
//         }}
//       >
//         <ul className="nav flex-column text-center bg-light p-3">
//           <li className="nav-item">
//             <Link className="nav-link" to="/" onClick={toggleMenu}>
//               Home
//             </Link>
//           </li>
//           <li className="nav-item">
//             <Link className="nav-link" to="/herbalProduct" onClick={toggleMenu}>
//               sthachu
//             </Link>
//           </li>
//           <li className="nav-item">
//             <Link className="nav-link" to="/gardenProduct" onClick={toggleMenu}>
//               Jewellary
//             </Link>
//           </li>
//           <li className="nav-item">
//             <Link className="nav-link" to="/yogaProduct" onClick={toggleMenu}>
//               Thanjavur Art
//             </Link>
//           </li>
//           <li className="nav-item">
//             <Link className="nav-link" to="/foodProduct" onClick={toggleMenu}>
//               Others
//             </Link>
//           </li>
//           <li className="nav-item">
//             <Link className="nav-link" to="/about" onClick={toggleMenu}>
//               About
//             </Link>
//           </li>
//           <li className="nav-item">
//             <Link
//               to="/cart/:productId"
//               className="nav-icon position-relative text-decoration-none"
//               onClick={toggleMenu}
//             >
//               <AiOutlineShoppingCart style={{ fontSize: "1.7em" }} />
//             </Link>
//           </li>
//           <li className="nav-item">
//             <Link
//               to="/profile/:productId"
//               className="nav-icon position-relative text-decoration-none"
//               onClick={toggleMenu}
//             >
//               <AiOutlineUser style={{ fontSize: "1.7em" }} />
//             </Link>
//           </li>
//         </ul>
//       </div>
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiOutlineShoppingCart, AiOutlineUser } from "react-icons/ai";
import Logo from "../../assets/img/j.png"

export default function Mobile() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden"; // Prevent scrolling
    } else {
      document.body.style.overflow = "auto"; // Restore scrolling
    }

    const handleScroll = () => setMenuOpen(false);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("scroll", handleScroll);
    };
  }, [menuOpen]);

  return (
    <>
      {/* Fixed Navbar */}
      <Nav
        className="navbar navbar-light shadow d-lg-none fixed-top"
        style={{
          // backgroundColor: "rgb(245, 212, 78)",
          backgroundColor:"black",
          zIndex: 1050,
        }}
      >
        <div className="container d-flex justify-content-between align-items-center">
          <Link
            className="logo align-self-center"
            to="/"
            style={{ width: "50%", textDecoration: "none", color: "black" }}
          >
            {/* chakara art and craft */}
             <img src={Logo} alt="chakara logo" height="35px" width="50%" />
          </Link>

          <button
            className="navbar-toggler border-1 "
            type="button"
            onClick={toggleMenu}
          >
            {/* <span className="navbar-toggler-icon"></span> */}
            <i className="fas fa-bars" style={{ color: "white", fontSize: "24px" }}></i>
          </button>
        </div>
      </Nav>

      {/* Sidebar Menu */}
      <div
        className="sidebar-menu"
        style={{
          position: "fixed",
          top: "0",
          left: menuOpen ? "0" : "-250px",
          width: "250px",
          height: "100vh",
          backgroundColor: "white",
          boxShadow: "2px 0 5px rgba(239, 225, 225, 0.93)",
          transition: "left 0.3s ease-in-out",
          zIndex: 1049,
        }}
      >
        <ul className="nav flex-column text-center p-3">
          <li className="nav-item" style={{marginTop:"35px"}}>
            <Link className="nav-link" to="/" onClick={toggleMenu}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/herbalProduct" onClick={toggleMenu}>
              statue
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/gardenProduct" onClick={toggleMenu}>
              Jewellery
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/yogaProduct" onClick={toggleMenu}>
              Thanjavur Art
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/foodProduct" onClick={toggleMenu}>
              Others
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about" onClick={toggleMenu}>
              About
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/cart/:productId"
              className="nav-icon"
              onClick={toggleMenu}
            >
              <AiOutlineShoppingCart style={{ fontSize: "1.7em" }} />
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/profile/:productId"
              className="nav-icon"
              onClick={toggleMenu}
            >
              <AiOutlineUser style={{ fontSize: "1.7em" }} />
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
}
